import { css } from '@emotion/react';
import { theme } from 'styles/theme/theme';

export const modalInputStyle = css`
  caret-color: ${theme.colors.AccentNaplesYellow};
  background-color: ${theme.colors.GrayF2};
  border: 1px solid transparent;
  max-height: 36px !important;
`;

export const modalButton = css`
  width: 130px;
  min-width: 130px;
  height: 100%;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 8px;

  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  color: ${theme.colors.SurfaceRaisinBlack50};
  background-color: ${theme.colors.AccentNaplesYellow};

  &:disabled {
    background-color: ${theme.colors.DarkBlue100};
    color: ${theme.colors.Gray};
  }
`;

export const modalError = css`
  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${theme.colors.error};
`;
